import { ComponentProps } from 'react';

export type ApplicationsListProps = Omit<ComponentProps<'section'>, 'children'>;

export enum ApplicationStatus {
  APPROVED = 'approved',
  DENIED = 'denied',
}

export enum ApplicationCategory {
  TECH = 'tech',
  INFRA = 'infrastructure',
  CONTENT = 'content',
  COMMUNITY = 'community',
  RESEARCH = 'research',
  ECOSYSTEM = 'ecosystem',
  DEFI = 'defi',
  AI = 'ai',
  RWA = 'rwa',
  GAMING = 'gaming',
  NFT = 'nft',
  OTHER = 'other',
}

export enum ApplicationTeamType {
  INDIVIDUAL = 'individual',
  SMALL_TEAM = 'small_team',
  ORGANIZATION = 'organization',
  OTHER = 'other',
}

export enum ApplicationProgressReportingFrequency {
  DAILY = 'daily',
  WEEKLY = 'weekly',
  MONTHLY = 'monthly',
}

export type Application = {
  id: string;
  name: string;
  description: string;
  applicant: string;
  teamType: ApplicationTeamType;
  teamDescription: string;
  email: string;
  fundingRequest: number;
  fundingGranted?: number;
  detailedBudget: string;
  startDate: Date;
  endDate: Date;
  milestones: string;
  rationale: string;
  categories: ApplicationCategory[];
  progressReportingFrequency: ApplicationProgressReportingFrequency;
  demoUrl: string;
  onePagerUrl: string;
  primaryCategory?: ApplicationCategory; // This should be manually picked by the approver
  status?: ApplicationStatus; // No status = Unrated
  ratedAt?: Date;
  createdAt: Date;
};

export const applicationTeamTypeMap: Record<ApplicationTeamType, string> = {
  [ApplicationTeamType.INDIVIDUAL]: 'Solo developer / individual',
  [ApplicationTeamType.SMALL_TEAM]: 'Small team / startup',
  [ApplicationTeamType.ORGANIZATION]: 'Registered company or organization',
  [ApplicationTeamType.OTHER]: 'Other',
};

export const applicationProgressReportingFrequencyMap: Record<
  ApplicationProgressReportingFrequency,
  string
> = {
  [ApplicationProgressReportingFrequency.DAILY]: 'Daily',
  [ApplicationProgressReportingFrequency.WEEKLY]: 'Weekly',
  [ApplicationProgressReportingFrequency.MONTHLY]: 'Monthly',
};
